import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import parse from "html-react-parser";
import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import { getInvoiceDetail } from "../../services/finance/invoice";
import { formatDate } from "../../utils/utils";
import NumberFormat from "react-number-format";
import {
  getSharedDocuments,
  uploadSharedDocument,
} from "../../services/commons";
import DialogLayout from "../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import { CustomOutlinedDisabledTextField } from "../../partials/content/Forms";
import copy from "clipboard-copy";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import Swal from "sweetalert2";
import { Badge } from "react-bootstrap";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
const CustomPrintOutInvoice = ({
  title = "INVOICE",
  invoiceID = 0,
  currentDateTime = DateTime.now(),
}) => {
  const { companyProfile, reload } = useGlobalData();
  const [invoice, setInvoice] = useState({
    ID: 0,
    invoiceCode: "",
    customer: { customerName: "" },
    currency: { currencyCode: "" },
    glAccount: { bankAccount: { bankName: "", bankBranch: "", bankCode: "" } },
    invoiceItem: [],
  });
  const [openSharedDocument, setOpenSharedDocument] = useState(false);
  const [sharedDocumentLink, setSharedDocumentLink] = useState("");
  const timestamp = DateTime.now().toFormat("yyyy-MM-dd, hh:mm a ZZZZZ (ZZZZ)");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [isCopySucceed, setIsCopySucceed] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    getInvoiceData(invoiceID);
    setFrom(companyProfile.companyName);
    setWhatsappNumber(invoice.customer.addressPhone);
    getSharedDocumentData("INVO", invoice.ID);
  }, [reload]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "@page { size: ledger; !important; } @media print { body { -webkit-print-color-adjust: exact; !important; } }",
    documentTitle: `Invoice_${from}_${to}_${formatDate(currentDateTime, true)}`,
  });
  const handleDownloadPDF = () => {
    var opt = {
      margin: 0,
      filename: `Invoice_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .save();
  };
  const handleSharePDF = () => {
    let fileName = `Invoice_${from}_${to}_${formatDate(
      currentDateTime,
      true
    )}.pdf`;
    let fileNameConverted = fileName.replace(/ /g, "").replace(/:/g, "");
    var opt = {
      margin: 0,
      filename: `Invoice_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .output("datauristring")
      .then(function(pdf) {
        const filesData = new FormData();
        const preBlob = dataURItoBlob(pdf);
        const file = new File([preBlob], fileNameConverted, {
          type: "application/pdf",
        });
        filesData.append("files[]", file);
        filesData.append("docID", invoice.ID);
        filesData.append("docType", "INVO");
        uploadSharedDocument(filesData).then((response) => {
          getSharedDocumentData("INVO", invoice.ID);
          setOpenSharedDocument(true);
        });
      });
  };

  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  return (
    <React.Fragment>
      <div className="row justify-content-center py-2 px-5 py-md-2 px-md-0">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-label-success btn-md btn-pill btn-bold"
              onClick={handleDownloadPDF}
            >
              <i className="fas fa-cloud-download-alt"></i>
              Download Invoice
            </button>
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold"
              onClick={handleSharePDF}
            >
              <i className="fas fa-share-alt"></i>
              Share Invoice
            </button>
            <button
              type="button"
              className="btn btn-label-info btn-md btn-pill btn-bold"
              onClick={handlePrint}
            >
              <i className="fas fa-print"></i>
              Print Invoice
            </button>
          </div>
        </div>
      </div>
      <div ref={componentRef} className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom overflow-hidden border-0">
            <div className="card-body p-0">
              <div className="row justify-content-center pt-5 pb-3 px-5 pt-md-5 pb-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between flex-row flex-xl-row flex-lg-row flex-md-row flex-sm-column">
                    <div className="d-flex flex-column px-0 mr-1">
                      <h1 className="display-5 kt-font-bolder text-dark mb-3 mr-1">
                        {title}
                      </h1>
                      <div className="mb-5">
                        <Typography variant="h6" className="kt-font-bolder">
                          <Badge
                            className="ml-1"
                            variant={
                              invoice.paymentStatus === 1
                                ? "danger"
                                : invoice.paymentStatus === 2
                                ? "warning"
                                : invoice.paymentStatus === 3
                                ? "success"
                                : null
                            }
                          >
                            {invoice.paymentStatus !== 0
                              ? invoice.paymentStatusDesc
                              : null}
                          </Badge>
                        </Typography>
                      </div>
                    </div>
                    <div className="d-flex flex-column align-items-md-end px-0 ml-1">
                      <div className="mb-3">
                        <Image
                          src={
                            companyProfile.companyProfileLogo.length > 0
                              ? companyProfile.companyProfileLogo[0].imagePath.includes(
                                  "?"
                                )
                                ? `${companyProfile.companyProfileLogo[0].imagePath}&v=${timestamp}`
                                : `${companyProfile.companyProfileLogo[0].imagePath}?v=${timestamp}`
                              : "/media/logos/logo-form-header.png"
                          }
                          style={{
                            maxHeight: "9rem",
                            maxWidth: "18rem",
                          }}
                          alt="Company Profile Logo"
                          fluid
                          crossOrigin="anonymous"
                        />
                      </div>
                      <div
                        className="d-flex flex-column align-items-md-end text-wrap"
                        style={{
                          maxWidth: "300px",
                        }}
                      >
                        <Typography className="kt-font-bolder text-dark text-md-right text-uppercase">
                          {companyProfile.companyName}
                        </Typography>
                        <Typography className="kt-font-bold text-muted text-md-right">
                          {companyProfile.fullAddress}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center bg-light py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between">
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        INVOICE NO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {invoice.invoiceCode}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        INVOICE DATE.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {formatDate(invoice.invoiceDate)}
                      </Typography>
                      <Typography className="kt-font-bolder text-dark mb-2">
                        DEADLINE DATE.
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-2">
                        {formatDate(invoice.deadlineDate)}
                      </Typography>
                    </div>
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        BILL TO.
                      </Typography>
                      <Typography className="kt-font-bold text-muted">
                        <strong>{invoice.customer.customerName}</strong>
                      </Typography>
                      <Typography className="kt-font-bold text-muted">
                        {invoice.fullAddress}
                      </Typography>
                    </div>
                    <div
                      className="d-flex flex-column flex-root text-wrap"
                      style={{
                        width: "200px",
                      }}
                    >
                      <Typography className="kt-font-bolder text-dark mb-2">
                        BILL CONTACT.
                      </Typography>
                      {invoice.contactName ? (
                        <React.Fragment>
                          <Typography className="kt-font-bold text-muted">
                            <strong>{invoice.contactName}</strong>
                          </Typography>
                          <Typography className="kt-font-bold text-muted">
                            {invoice.position}
                          </Typography>
                          <Typography className="kt-font-bold text-muted">
                            {invoice.contactPhone}
                          </Typography>
                          <Typography className="kt-font-bold text-muted">
                            {invoice.contactEmail}
                          </Typography>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Typography className="kt-font-bold text-muted">
                            -
                          </Typography>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th style={{ width: "25%" }} className="pl-0">
                            <Typography className="kt-font-bolder text-muted">
                              ITEM NAME
                            </Typography>
                          </th>
                          <th style={{ width: "15%" }}>
                            <Typography className="kt-font-bolder text-muted">
                              QTY
                            </Typography>
                          </th>
                          <th style={{ width: "20%" }}>
                            <Typography className="text-right kt-font-bolder text-muted">
                              UNIT PRICE
                            </Typography>
                          </th>
                          <th style={{ width: "20%" }}>
                            <Typography className="text-right kt-font-bolder text-muted">
                              ITEM DISCOUNT
                            </Typography>
                          </th>
                          <th style={{ width: "20%" }} className="pr-0">
                            <Typography className="text-right kt-font-bolder text-muted">
                              TOTAL PRICE
                            </Typography>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.invoiceItem &&
                        invoice.invoiceItem.length > 0 ? (
                          <React.Fragment>
                            {invoice.invoiceItem.map((item, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr className="kt-font-bolder border-bottom-0">
                                    <td className="pl-0 py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.itemCode} {item.itemName}
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography className="kt-font-bold text-dark">
                                        {item.qty} {item.uom.uomName}
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography
                                        component="div"
                                        className="kt-font-bold text-dark text-right"
                                      >
                                        <NumberFormat
                                          value={item.unitPrice}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {invoice.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td className="py-2">
                                      <Typography
                                        component="div"
                                        className="kt-font-bold text-dark text-right"
                                      >
                                        <NumberFormat
                                          value={item.discountAmount}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {invoice.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                    <td className="pr-0 py-2">
                                      <Typography
                                        component="div"
                                        className="kt-font-bold text-dark text-right"
                                      >
                                        <NumberFormat
                                          value={item.totalPrice}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                          decimalScale={2}
                                          renderText={(value) => (
                                            <div className="float-right">
                                              {invoice.currencyCode} {value}
                                            </div>
                                          )}
                                        />
                                      </Typography>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          </React.Fragment>
                        ) : null}
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography className="text-right kt-font-bolder text-muted">
                              SUB TOTAL
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={invoice.subTotal}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {invoice.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography
                              component="div"
                              className="text-right kt-font-bolder text-muted"
                            >
                              <NumberFormat
                                value={invoice.discountPercent}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div>
                                    DISCOUNT{" ("}
                                    {value}
                                    {"%)"}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={invoice.discountAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    - {invoice.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography
                              component="div"
                              className="text-right kt-font-bolder text-muted"
                            >
                              <NumberFormat
                                value={invoice.taxPercent}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div>
                                    TAX{" ("}
                                    {value}
                                    {"%)"}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={invoice.taxAmount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {invoice.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography className="text-right kt-font-bolder text-muted">
                              ADDITIONAL COST
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={invoice.addCostTotal}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {invoice.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                        <tr className="kt-font-bolder border-bottom-0">
                          <td className="py-0 py-2" colSpan="4">
                            <Typography className="text-right kt-font-bolder text-muted">
                              GRAND TOTAL
                            </Typography>
                          </td>
                          <td className="pr-0 py-2">
                            <Typography
                              component="div"
                              className="text-dark kt-font-bold text-right"
                            >
                              <NumberFormat
                                value={invoice.grandTotal}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">
                                    {invoice.currencyCode} {value}
                                  </div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center bg-light py-3 px-5 py-md-3 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between flex-row flex-xl-row flex-lg-row flex-md-row flex-sm-column">
                    <div className="d-flex flex-column mb-3 mb-md-0 mr-1">
                      <div className="kt-font-bolder text-muted mt-3 mb-2">
                        <Typography className="kt-font-bolder text-muted">
                          NOTES OR SPECIAL INSTRUCTIONS.
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-dark">
                        {invoice.note ? (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            {parse(invoice.note)}
                          </Typography>
                        ) : (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            -
                          </Typography>
                        )}
                      </div>
                      <div className="kt-font-bolder text-muted mt-3 mb-2">
                        <Typography className="kt-font-bolder text-muted">
                          TERMS AND CONDITIONS.
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-dark">
                        {invoice.toc ? (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            {parse(invoice.toc)}
                          </Typography>
                        ) : (
                          <Typography
                            className="kt-font-bold text-dark text-wrap"
                            style={{ maxWidth: "420px" }}
                          >
                            -
                          </Typography>
                        )}
                      </div>
                    </div>
                    <div className="d-flex flex-column text-md-right ml-1">
                      <Typography
                        variant="h6"
                        className="kt-font-bolder text-muted mb-1"
                      >
                        BILLED AMOUNT {"(" + invoice.billPercent + " %)"}
                      </Typography>
                      <Typography
                        variant="h5"
                        component="div"
                        className="kt-font-bolder text-dark mb-1"
                      >
                        <NumberFormat
                          value={invoice.billAmount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">
                              {invoice.currencyCode} {value}
                            </div>
                          )}
                        />
                      </Typography>
                      <Typography className="kt-font-bold text-muted mb-1">
                        {invoice.taxAmount > 0
                          ? "Taxes Included"
                          : "Taxes Not Included"}
                      </Typography>
                      {invoice.glAccount.bankAccount.bankName !== "" ? (
                        <React.Fragment>
                          <div className="kt-font-bolder text-muted mt-2 mb-2">
                            <Typography className="kt-font-bolder text-muted">
                              BANK TRANSFER.
                            </Typography>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="kt-font-bolder text-dark mr-5">
                              <Typography className="kt-font-bolder text-dark">
                                Account Number:
                              </Typography>
                            </span>
                            <span className="kt-font-bold text-dark ml-5 text-right">
                              <Typography className="kt-font-bold text-dark text-right">
                                {invoice.glAccount.bankAccount.accountNo}
                              </Typography>
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="kt-font-bolder text-dark mr-5">
                              <Typography className="kt-font-bolder text-dark">
                                Account Holder:
                              </Typography>
                            </span>
                            <span className="kt-font-bold text-dark ml-5 text-right">
                              <Typography className="kt-font-bold text-dark text-right">
                                {invoice.glAccount.bankAccount.accountHolder}
                              </Typography>
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="kt-font-bolder text-dark mr-5">
                              <Typography className="kt-font-bolder text-dark">
                                Bank Name:
                              </Typography>
                            </span>
                            <span className="kt-font-bold text-dark ml-5 text-right">
                              <Typography className="kt-font-bold text-dark text-right">
                                {invoice.glAccount.bankAccount.bankName}
                              </Typography>
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="kt-font-bolder text-dark mr-5">
                              <Typography className="kt-font-bolder text-dark">
                                Bank Branch:
                              </Typography>
                            </span>
                            <span className="kt-font-bold text-dark ml-5 text-right">
                              <Typography className="kt-font-bold text-dark text-right">
                                {invoice.glAccount.bankAccount.bankBranch}
                              </Typography>
                            </span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span className="kt-font-bolder text-dark mr-5">
                              <Typography className="kt-font-bolder text-dark">
                                SWIFT / Bank Code:
                              </Typography>
                            </span>
                            <span className="kt-font-bold text-dark ml-5 text-right">
                              <Typography className="kt-font-bold text-dark text-right">
                                {invoice.glAccount.bankAccount.bankCode}
                              </Typography>
                            </span>
                          </div>
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center pt-3 pb-5 px-5 pt-md-3 pb-md-5 px-md-5">
                <div className="col-md-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          If you have any questions about this Invoice, please
                          contact <strong>{companyProfile.companyName}</strong>
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          <strong>{companyProfile.fullAddress}</strong>
                        </Typography>
                      </div>
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          Tel: <strong>{companyProfile.phone}</strong>, Email:{" "}
                          <strong>{companyProfile.email}</strong>, Website:{" "}
                          <strong>{companyProfile.website}</strong>
                        </Typography>
                      </div>
                    </div>
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-muted text-center">
                        <Typography className="kt-font-bold text-muted text-center">
                          Thank you for your business!
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-column mb-2 mt-2">
                      <div className="kt-font-bold text-center">
                        <Typography className="kt-font-bold text-center">
                          <i>
                            This is a computer-generated document. No signature
                            is required.
                          </i>
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSharedDocument}
        title={"Shared Document Link"}
        onCloseDialog={() => {
          setOpenSharedDocument(false);
        }}
        //fullScreen={false}
        maxWIdth="sm"
      >
        <React.Fragment>
          <CustomOutlinedDisabledTextField
            label="Shared Document URL Link"
            value={sharedDocumentLink}
          />
        </React.Fragment>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSharedDocument(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={(e) => {
              e.preventDefault();
              let message = sharedDocumentLink;
              if (whatsappNumber === "") {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Failed",
                  text: "Customer Whatsapp Number cannot be empty",
                  icon: "error",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              } else {
                // Regex expression to remove all characters which are NOT alphanumeric
                let number = whatsappNumber
                  .replace(/[^\w\s]/gi, "")
                  .replace(/ /g, "");

                // Appending the phone number to the URL
                let url = `https://web.whatsapp.com/send?phone=${number}`;

                // Appending the message to the URL by encoding it
                url += `&text=${encodeURI(message)}&app_absent=0`;

                // Open our newly created URL in a new tab to send the message
                window.open(url);
              }
            }}
          >
            <i className="flaticon-whatsapp"></i>
            Send To Whatsapp
          </button>
          <BootstrapTooltip
            title="URL Copied"
            open={isCopySucceed}
            onClose={() => {
              setIsCopySucceed(false);
            }}
          >
            <button
              type="button"
              className="btn btn-dark btn-md btn-pill btn-bold"
              onClick={() => {
                copy(sharedDocumentLink).then(() => {
                  setIsCopySucceed(true);
                });
              }}
            >
              <i className="fas fa-copy"></i>
              Copy To Clipboard
            </button>
          </BootstrapTooltip>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getInvoiceData(invoiceID) {
    if (invoiceID > 0) {
      const response = await getInvoiceDetail(invoiceID);
      const { data } = response.data;
      setInvoice(data.invoice);
      setTo(data.invoice.customer.customerName);
    }
  }

  async function getSharedDocumentData(docType, docID) {
    const response = await getSharedDocuments(docType, docID);
    const { data } = response.data;
    let sharedDocuments = data.sharedDocuments;
    if (sharedDocuments.length > 0) {
      setSharedDocumentLink(sharedDocuments[0].filePath);
    }
  }
};

export default CustomPrintOutInvoice;
